import {
  AlertDialog,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from '@/components/alert-dialog/alert-dialog'
import { Button } from '@/components/button/button'

import { cn } from '@/lib/utils'

export interface ProcessingTimeDataDeleteConfirmDialogProps {
  isOpen: boolean
  isDeleting?: boolean
  close: VoidFunction
  onClickConfirmButton: VoidFunction
}

export const ProcessingTimeDataDeleteConfirmDialog = ({
  isOpen,
  isDeleting = false,
  close,
  onClickConfirmButton,
}: ProcessingTimeDataDeleteConfirmDialogProps) => {
  const handleChangeOpen = (open: boolean) => {
    if (!open) {
      close()
      return
    }
  }

  const isDisabledCancelButton = isDeleting
  const isLoadingConfirmButton = isDeleting

  return (
    <AlertDialog open={isOpen} onOpenChange={handleChangeOpen}>
      <AlertDialogContent>
        <AlertDialogHeader>
          <AlertDialogTitle>Delete Processing Time Data</AlertDialogTitle>
          <AlertDialogDescription>Are you sure you want to delete processing time data?</AlertDialogDescription>
        </AlertDialogHeader>

        <AlertDialogFooter className={cn('flex')}>
          <Button
            type="button"
            variant="secondary"
            disabled={isDisabledCancelButton}
            className={cn('w-1/3')}
            onClick={close}
          >
            Cancel
          </Button>
          <Button
            type="button"
            variant="destructive"
            loading={isLoadingConfirmButton}
            className={cn('w-2/3')}
            onClick={onClickConfirmButton}
          >
            Delete
          </Button>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  )
}
